export default __webpack_public_path__ + "static/media/partner-stella-fantasy.bb4db647.png";